<template>
  <v-dialog :value="showCaja" persistent scrollable max-width="960px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="mc-titulo">
        <div class="mc-titulo-texto">
          <span class="text-h6">Cajas</span>
          <div class="mc-punto">
            <span class="mc-punto-nombre">{{ sucursal.nombre }}</span>
            <v-chip x-small label :color="sucursal.en_pronto_pagos ? 'blue lighten-5' : 'grey lighten-4'"
              :text-color="sucursal.en_pronto_pagos ? 'blue darken-3' : 'grey darken-3'">
              {{ sucursal.en_pronto_pagos ? "Pronto Pagos" : "APILINK" }}
            </v-chip>
            <span v-if="sucursal.codigo_sucursal_link" class="mc-secundario">
              Sucursal {{ sucursal.codigo_sucursal_link }}
            </span>
          </div>
        </div>
        <v-btn icon aria-label="Cerrar" @click="cierreCaja()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="mc-cuerpo">
        <div class="mc-herramientas">
          <v-text-field v-model="searchEmail" label="Buscar por correo de usuario" prepend-inner-icon="mdi-magnify"
            outlined dense hide-details clearable class="mc-buscar"></v-text-field>
          <v-btn v-if="!showFormCaja" color="primary" depressed @click="openNewCaja()">
            <v-icon left>mdi-plus</v-icon>
            Nueva caja
          </v-btn>
        </div>

        <v-expand-transition>
          <v-sheet v-show="showFormCaja" outlined rounded class="mc-formulario">
            <div class="mc-formulario-titulo">
              {{ editCaja ? "Editar caja" : "Nueva caja" }}
            </div>
            <v-alert v-if="errorForm" type="error" text dense class="mb-4">
              {{ errorForm }}
            </v-alert>
            <v-form ref="form_create" v-model="valid2" lazy-validation>
              <v-text-field v-model="currentCaja.descripcion" :counter="45" :rules="namecuenta"
                label="Nombre de la caja" hint="Letras, números, - y _, sin espacios. Ej: Caja_Principal-1"
                persistent-hint class="mb-4" required></v-text-field>
              <v-autocomplete v-model="currentCaja.cuenta" :items="usuarios" item-text="Nombre" item-value="Id"
                label="Usuarios que cobran con esta caja" multiple small-chips deletable-chips
                no-data-text="Este cliente no tiene usuarios">
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.Nombre }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.User">{{ item.User }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <div class="mc-formulario-acciones">
                <v-btn text @click="closeNewCaja()">Cancelar</v-btn>
                <v-btn color="primary" depressed :disabled="!valid2" :loading="guardando"
                  @click="editCaja ? handleUpdate() : handleStore()">
                  {{ editCaja ? "Guardar cambios" : "Crear caja" }}
                </v-btn>
              </div>
            </v-form>
          </v-sheet>
        </v-expand-transition>

        <v-alert v-if="errored" type="error" text outlined class="mb-4">
          <div class="mc-alerta">
            <span>No pudimos traer las cajas. Probá de nuevo en unos minutos.</span>
            <v-btn small text color="error" @click="getDatosCaja(sucursal.id)">Reintentar</v-btn>
          </div>
        </v-alert>

        <v-data-table :headers="headersCaja" :items="itemsCajaFormatted" :loading="cargandoCaja"
          :items-per-page="rowsPerPage" :expanded.sync="expanded" item-key="Id" single-expand hide-default-footer
          disable-sort loading-text="Cargando cajas…" class="mc-tabla">
          <template v-slot:no-data>
            <div v-if="searchEmail" class="mc-vacio">
              <p class="mc-vacio-texto">Ninguna caja de esta página tiene un usuario con ese correo.</p>
            </div>
            <div v-else-if="!errored" class="mc-vacio">
              <v-icon size="40" color="grey lighten-1">mdi-cash-register</v-icon>
              <p class="mc-vacio-titulo">Este punto de venta todavía no tiene cajas</p>
              <p class="mc-vacio-texto">Cada caja genera su QR y se asigna a los usuarios que cobran con ella.</p>
              <v-btn v-if="!showFormCaja" color="primary" depressed @click="openNewCaja()">
                <v-icon left>mdi-plus</v-icon>
                Crear la primera caja
              </v-btn>
            </div>
            <span v-else>Sin datos para mostrar.</span>
          </template>

          <template v-slot:[`item.descripcion`]="{ item }">
            <div class="mc-nombre">{{ item.descripcion }}</div>
            <div class="mc-secundario">Código {{ item.codigo_caja }}</div>
          </template>

          <template v-slot:[`item.activo`]="{ item }">
            <v-chip small :color="item.activo == 'Activo' ? 'green lighten-5' : 'grey lighten-3'"
              :text-color="item.activo == 'Activo' ? 'green darken-3' : 'grey darken-3'">
              <v-icon left x-small>
                {{ item.activo == "Activo" ? "mdi-check-circle" : "mdi-minus-circle" }}
              </v-icon>
              {{ item.activo }}
            </v-chip>
          </template>

          <template v-slot:[`item.usuarios`]="{ item }">
            <v-btn v-if="item.usuarios && item.usuarios.length" text small class="px-1"
              :aria-expanded="desplegada(item) ? 'true' : 'false'" @click="alternarUsuarios(item)">
              {{ item.usuarios.length }}
              {{ item.usuarios.length === 1 ? "usuario" : "usuarios" }}
              <v-icon small right>{{ desplegada(item) ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
            </v-btn>
            <span v-else class="mc-secundario">Sin usuarios</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="mc-acciones">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-btn icon :disabled="item.activo == 'Inactivo'" aria-label="Editar caja"
                      @click="openEdit(item.Id)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ item.activo == "Inactivo" ? "Activá la caja para editarla" : "Editar caja" }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon :aria-label="item.activo == 'Activo' ? 'Desactivar caja' : 'Activar caja'"
                    v-bind="attrs" v-on="on" @click="invertirActive(item)">
                    <v-icon>
                      {{ item.activo == "Activo" ? "mdi-toggle-switch" : "mdi-toggle-switch-off-outline" }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ item.activo == "Activo" ? "Desactivar caja" : "Activar caja" }}</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="mc-usuarios">
              <ul class="mc-usuarios-lista">
                <li v-for="(i, index) in item.usuarios" :key="index" class="mc-usuario">
                  <div>
                    <div class="mc-nombre">{{ i.Nombre }}</div>
                    <div class="mc-secundario">{{ i.User }}</div>
                  </div>
                  <v-btn small text color="error" @click="cerrarSesion(item, i)">
                    <v-icon left small>mdi-logout</v-icon>
                    Cerrar sesión
                  </v-btn>
                </li>
              </ul>
            </td>
          </template>
        </v-data-table>

        <div v-if="itemsCaja.length" class="mc-pie">
          <div class="mc-filas">
            <span>Filas por página</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn text small color="primary" v-on="on">
                  {{ rowsPerPage }}
                  <v-icon small>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item v-for="(number, index) in rowsPerPageArray" :key="index"
                  @click="updateRowsPerPage(number)">
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-pagination v-if="pagination.total > 1" v-model="pagination.page" :length="pagination.total"
            :total-visible="pagination.visible" @input="onPageChange"></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { Cuentas } from "../../../../../services/cuentas";
import formatDate from "../../../../../utils/formatDate";

export default {
  components: {
    name: "ModalCaja",
  },
  props: {
    showCaja: {
      default: false,
      type: Boolean,
    },
    sucursal: {
      type: Object,
      default: () => ({
        codigo_sucursal_link: "",
        fecha_alta: "",
        fecha_creacion: "",
        id: 0,
        nombre: "",
      }),
    },
    usuarios: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      showFormCaja: false,
      searchEmail: "",
      errored: false,
      errorForm: "",
      guardando: false,
      expanded: [],
      formatDate,
      currentCaja: {
        descripcion: "",
        fecha_alta: "",
        correo: "",
        cuenta: [],
      },
      valid2: false,
      editCaja: false,
      headersCaja: [
        { text: "Caja", value: "descripcion" },
        { text: "Vigente desde", value: "fecha_alta" },
        { text: "Estado", value: "activo" },
        { text: "Usuarios", value: "usuarios" },
        { text: "", value: "actions", align: "end" },
      ],
      // paginacion api
      pagination: {
        page: 1,
        total: 0,
        visible: 7,
      },
      rowsPerPageArray: [10, 20, 30],
      rowsPerPage: 10,
      cargandoCaja: false,
      itemsCaja: [],
      namecuenta: [
        (v) => !!v || "El nombre es obligatorio",
        (v) => (v && v.length <= 45) || "Máximo 45 caracteres",
        (v) =>
          /^[A-Za-z0-9_-]+$/.test(v) ||
          "Sin espacios ni símbolos, salvo - y _",
      ],
    };
  },
  watch: {
    showCaja(newVal) {
      if (newVal) {
        this.pagination.page = 1;
        this.getDatosCaja(this.sucursal.id);
      }
    },
  },
  computed: {
    itemsCajaFormatted() {
      let formatted = this.itemsCaja.map((item) => ({
        ...item,
        fecha_alta: formatDate(item.fecha_alta.substring(0, 10)),
      }));
      if (!this.searchEmail) return formatted;
      return formatted.filter(
        (item) =>
          item.usuarios &&
          item.usuarios.some((usuario) =>
            usuario.User.toLowerCase().includes(this.searchEmail.toLowerCase())
          )
      );
    },
  },
  methods: {
    // Los errores de APILINK/Pronto Pagos llegan como
    // `error: 400 ..., body: {"message":"..."}`: se muestra solo el message.
    mensajeApi(error, porDefecto) {
      const texto =
        error.response?.data?.statusMessage || error.response?.data?.message;
      if (!texto) return porDefecto;
      const cuerpo = texto.match(/body:\s*(\{.*\})\s*$/);
      if (cuerpo) {
        try {
          const json = JSON.parse(cuerpo[1]);
          if (json.message) return `${porDefecto}: ${json.message}`;
        } catch (e) {
          // cuerpo no es JSON: se muestra el texto tal cual
        }
      }
      return texto;
    },
    onPageChange() {
      this.getDatosCaja(this.sucursal.id);
    },
    desplegada(item) {
      return this.expanded.some((e) => e.Id === item.Id);
    },
    alternarUsuarios(item) {
      this.expanded = this.desplegada(item) ? [] : [item];
    },
    openEdit(idCaja) {
      if (this.showFormCaja) this.closeNewCaja();

      const item = this.itemsCaja.find((c) => c.Id == idCaja);
      item.cuenta = item.usuarios?.map((u) => u.Id);

      this.editCaja = true;
      this.currentCaja = { ...item };
      this.showFormCaja = true;
    },
    openNewCaja() {
      if (this.showFormCaja) this.closeNewCaja();
      this.showFormCaja = true;
    },
    cierreCaja() {
      this.$emit("closeModalCaja");
      this.searchEmail = "";
      this.itemsCaja = [];
      this.expanded = [];
      this.errored = false;
      this.closeNewCaja();
    },
    closeNewCaja() {
      this.editCaja = false;
      this.showFormCaja = false;
      this.errorForm = "";
      if (this.$refs.form_create) this.$refs.form_create.resetValidation();
      this.currentCaja = {
        descripcion: "",
        fecha_alta: "",
        correo: "",
        cuenta: [],
      };
    },
    updateRowsPerPage(number) {
      this.rowsPerPage = number;
      this.pagination.page = 1;
      this.getDatosCaja(this.sucursal.id);
    },
    toast(name, msg, type, color) {
      this.$toastr.Add({
        name: name,
        title: "",
        msg: msg,
        clickClose: true,
        type: type,
        preventDuplicates: true,
        style: {
          color: "white",
          backgroundColor: color,
          width: "300px",
        },
      });
    },
    handleUpdate() {
      if (this.$refs.form_create.validate()) {
        this.updateCaja();
      } else {
        this.toast(
          "ErrorRequest",
          "Debe completar todos los datos",
          "info",
          "primary"
        );
      }
    },
    handleStore() {
      if (this.$refs.form_create.validate()) {
        this.storeCaja();
      } else {
        this.toast(
          "ErrorRequest",
          "Debe completar todos los datos",
          "info",
          "primary"
        );
      }
    },
    async deleteCaja(item) {
      const { isConfirmed } = await this.$swal.fire({
        title: "¿Esta seguro?",
        text: "Esta acción eliminará el contacto",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Si, continuar",
        denyButtonText: "Cancelar",
      });

      if (isConfirmed) this.delete(item.Id);
    },
    getDatosCaja: function(id_caja) {
      this.cargandoCaja = true;
      this.errored = false;
      let params = {
        number: this.pagination.page,
        size: this.rowsPerPage,
        PuntosVentaId: id_caja,
      };
      Cuentas.getDatosCaja(params)
        .then((response) => {
          if (response.data.data.CajasCobro) {
            this.itemsCaja = response.data.data.CajasCobro.map((c) => ({
              ...c,
              activo: c.activo ? "Activo" : "Inactivo",
            }));
            this.pagination.page = response.data.data.meta.page.currentPage;
            this.pagination.total = response.data.data.meta.page.lastPage;
          } else {
            this.itemsCaja = [];
            this.pagination.page = 1;
            this.pagination.total = 0;
          }
        })
        .catch(() => {
          this.itemsCaja = [];
          this.errored = true;
        })
        .finally(() => {
          this.cargandoCaja = false;
        });
    },
    updateCaja: function() {
      this.currentCaja.fecha_alta =
        moment().format("YYYY-MM-DD") + "T00:00:00Z";
      this.guardando = true;
      this.errorForm = "";
      let body = {
        descripcion: this.currentCaja.descripcion,
        fecha_alta: this.currentCaja.fecha_alta, //fecha minima actual
        Id: this.currentCaja.Id,
      };

      if (this.currentCaja.cuenta) {
        body.usuariosAsignados = this.currentCaja.cuenta.toString();
      }

      Cuentas.updateCaja(body)
        .then((response) => {
          if (response.status == 200) {
            this.getDatosCaja(this.sucursal.id);
            this.toast(
              "SuccessRequest",
              "Se actualizaron los datos correctamente",
              "success",
              "green"
            );
            this.closeNewCaja();
          }
        })
        .catch((error) => {
          this.errorForm = this.mensajeApi(error, "No se pudo actualizar la caja");
        })
        .finally(() => {
          this.guardando = false;
        });
    },
    storeCaja: function() {
      this.guardando = true;
      this.errorForm = "";
      let body = {
        descripcion: this.currentCaja.descripcion,
        fecha_alta: moment().format("YYYY-MM-DD") + "T00:00:00Z", //fecha minima actual
        puntos_ventas_id: this.sucursal.id,
        sucursal_codigo: this.sucursal.codigo_sucursal_link,
        cuenta_id: Number(this.$route.params.cuenta_id),
      };

      if (this.currentCaja.cuenta) {
        body.usuariosAsignados = this.currentCaja.cuenta.toString();
      }

      Cuentas.storeCaja(body)
        .then((response) => {
          if (response.status == 200) {
            this.getDatosCaja(this.sucursal.id);
            this.toast(
              "SuccessRequest",
              "La caja se creó correctamente",
              "success",
              "green"
            );
            this.closeNewCaja();
          }
        })
        .catch((error) => {
          // El mensaje de la API dice qué falló (APILINK, Pronto Pagos, datos).
          this.errorForm = this.mensajeApi(error, "No se pudo crear la caja");
        })
        .finally(() => {
          this.guardando = false;
        });
    },
    delete: function(id_caja) {
      this.cargandoCaja = true;
      Cuentas.deleteCaja(id_caja)
        .then((response) => {
          if (response.status == 200) {
            this.toast(
              "SuccessRequest",
              "Caja cobro eliminado correctamente",
              "success",
              "primary"
            );
            this.getDatosCaja(this.sucursal.id);
          }
        })
        .catch((error) => {
          this.toast("ErrorRequest", error, "warning", "danger");
        })
        .finally(() => {
          this.cargandoCaja = false;
        });
    },
    invertirActive: async function(item) {
      const activa = item.activo == "Activo";
      const { isConfirmed } = await this.$swal.fire({
        title: activa ? "¿Desactivar la caja?" : "¿Activar la caja?",
        text: activa
          ? "No se va a poder cobrar con esta caja hasta que la vuelvas a activar."
          : "Se va a poder volver a cobrar con esta caja.",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: activa ? "Sí, desactivar" : "Sí, activar",
        denyButtonText: "Cancelar",
      });

      if (isConfirmed) {
        this.cargandoCaja = true;
        let body = {
          Id: item.Id,
          activo: !activa,
        };
        if (item.usuarios) {
          body.usuariosAsignados = item.usuarios.map((u) => u.Id).toString();
        }
        Cuentas.updateCaja(body)
          .then((response) => {
            if (response.status == 200) {
              this.getDatosCaja(this.sucursal.id);
              this.toast(
                "SuccessRequest",
                "Se actualizaron los datos correctamente",
                "success",
                "green"
              );
              this.closeNewCaja();
            }
          })
          .catch((error) => {
            this.$toastr.e(
              error.response?.data?.statusMessage ||
              "No se pudo cambiar el estado de la caja"
            );
          })
          .finally(() => {
            this.cargandoCaja = false;
          });
      }
    },
    cerrarSesion: async function(item, i) {
      const { isConfirmed } = await this.$swal.fire({
        title: "¿Cerrar la sesión?",
        text: `${i.Nombre} deja de estar conectado a la caja ${item.descripcion}.`,
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, cerrar sesión",
        denyButtonText: "Cancelar",
      });
      if (isConfirmed) {
        this.cargandoCaja = true;
        const body = {
          user_id: i.Id,
          caja_id: item.Id,
        };

        Cuentas.cerrarSesion(body)
          .then((response) => {
            if (response.status == 200) {
              this.getDatosCaja(this.sucursal.id);
              this.$toastr.s("Cierre de sesion exitoso");
            }
          })
          .catch(() => {
            this.$toastr.e("Ocurrió un error al cerrar la sesión");
          })
          .finally(() => {
            this.cargandoCaja = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.mc-titulo {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 12px;
}

.mc-titulo-texto {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  text-align: left;
}

/* La app pinta en rojo todos los mensajes de los campos; acá las ayudas van en gris
   y solo los errores en rojo. */
.mc-formulario>>>.v-messages:not(.error--text) {
  color: rgba(0, 0, 0, 0.6);
}

.mc-punto {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.875rem;
  line-height: 1.4;
}

.mc-punto-nombre {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.mc-cuerpo {
  padding-top: 16px !important;
}

.mc-herramientas {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.mc-buscar {
  flex: 1 1 260px;
  max-width: 420px;
}

.mc-formulario {
  padding: 16px 20px 12px;
  margin-bottom: 16px;
  text-align: left;
}

.mc-formulario-titulo {
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 12px;
}

.mc-formulario-acciones {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}

.mc-alerta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.mc-tabla>>>th {
  white-space: nowrap;
}

.mc-tabla>>>td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.mc-tabla>>>tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

.mc-nombre {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.mc-secundario {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.6);
  font-variant-numeric: tabular-nums;
}

.mc-acciones {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.mc-usuarios {
  background: #f6f8f6;
}

.mc-usuarios-lista {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}

.mc-usuario {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  text-align: left;
}

.mc-usuario+.mc-usuario {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.mc-vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 32px 16px;
}

.mc-vacio-titulo {
  margin: 8px 0 0;
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.mc-vacio-texto {
  margin: 0 0 12px;
  color: rgba(0, 0, 0, 0.6);
}

.mc-pie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 12px;
}

.mc-filas {
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
}
</style>
